<template>
  <div class="view-container pt-5 pb-6 px-8 fill-height d-flex flex-column">
    <slot />
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.view-container {
  background-color: var(--white);
  border-radius: 12px;
}
</style>